import { Alert } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import PlaybookFlow from "./PlaybookFlow";
import { OtelContext } from "./context";

export default function PlaybookViewer(props) {
  const [playbook, setPlaybook] = useState({});
  const [error, setError] = useState();
  const tracer = useContext(OtelContext);

  const params = new URLSearchParams(window.location.search);
  const urlFromQuery = params.get("playbook");
  const playbookURL = props.url || urlFromQuery;

  useEffect(() => {
    if (!playbookURL && !props.json) {
      return;
    }
    async function fetchData() {
      try {
        let playbookJSON;
        if (playbookURL) {
          const response = await fetch(playbookURL);

          if (response.status !== 200 && response.status !== 201) {
            throw new Error(`Status Code ${response.status}`);
          }

          playbookJSON = await response.json();
        } else if (props.json) {
          playbookJSON = props.json;
        }

        if (!String(playbookJSON["coa"]["schema"]).startsWith("5")) {
          console.error(playbookJSON["coa"]["schema"]);
          throw new Error(
            `Playbook schema unsupported : '${playbookJSON["coa"]["schema"]}' -
            Only playbooks created with the modern SOAR Visual Playbook Editor (schema 5.x) are supported at this time.`
          );
        }

        setPlaybook(playbookJSON);

        const playbookName = (playbookURL
          ? playbookURL.substring(playbookURL.lastIndexOf("/") + 1).replace(".json", "")
          : "Provided JSON");

        const span = tracer.startSpan("playbook.load", {
          attributes: {
            "workflow.name": playbookName,
            "workflow.playbook.url": playbookURL || "Provided JSON",
            "location.href": playbookURL || "Provided JSON",
            "playbook.url": playbookURL || "Provided JSON",
            playbook: playbookURL || "Provided JSON",
          },
        });

        // time passes
        span.end();
      } catch (err) {
        const error = new Error("Error Loading Playbook: " + err.message);
        setError(error);
        throw error;
      }
    }
    fetchData();
  }, [playbookURL, tracer, props.json]);

  return (
    <>
      {error ? (
        <Alert severity="error">{error.message}</Alert>
      ) : (
        <></>
      )}
      {Object.keys(playbook).length > 0 ? (
        <PlaybookFlow playbook={playbook}></PlaybookFlow>
      ) : (
        <></>
      )}
    </>
  );
}
